import { createAction } from "@reduxjs/toolkit";
import type { StudentEvaluationVM } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const educationalAdvisorRetrieveEvaluationsGroupedByStudent = createApiThunk<StudentEvaluationVM[], void>(
  "evaluationsGroupedByStudents/educationalAdvisorRetrieveEvaluationsGroupedByStudent",
  async (_: void, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.getEvaluationsGroupedByStudent();
  },
);

export const resetEducationalAdvisorRetrieveEvaluationsGroupedByStudent = createAction(
  "evaluationsGroupedByStudents/resetEducationalAdvisorRetrieveEvaluationsGroupedByStudent",
);
